'use client';
import React, { useEffect, useRef, useState } from "react";

const MetricsSection = () => {
  const metrics = [
    { target: 12000, label: "WISE Program Students", format: "+" },
    { target: 300, label: "Industry Partners", format: "+" },
    { target: 30, label: "Sectors", format: "+" },
    { target: 3000, label: "Graduates Placed Across 15+ States", format: "+" },
    { target: 100, label: "Learn & Earn", format: "%" },
  ];

  const sectionRef = useRef(null);
  const hasAnimatedRef = useRef(false);

  const [values, setValues] = useState(metrics.map(() => 0));

  useEffect(() => {
    const sectionEl = sectionRef.current;
    if (!sectionEl) return;

    const animateAll = () => {
      const duration = 2000; // ms
      const start = performance.now();

      const step = (now) => {
        const progress = Math.min((now - start) / duration, 1);

        setValues(
          metrics.map((m) => {
            // ease-out for nicer feel
            const eased = 1 - Math.pow(1 - progress, 3);
            return Math.round(m.target * eased);
          })
        );

        if (progress < 1) requestAnimationFrame(step);
      };

      requestAnimationFrame(step);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting && !hasAnimatedRef.current) {
          hasAnimatedRef.current = true; // <-- ensures it runs only once
          animateAll();
          observer.disconnect(); // no need to keep observing
        }
      },
      { threshold: 0.4 }
    );

    observer.observe(sectionEl);

    return () => observer.disconnect();
  }, [metrics]);

  const formatValue = (value, format) => {
    const formatted = value.toLocaleString();
    if (format === "%") return `${formatted}%`;
    // default "+"
    return `${formatted}+`;
  };

  return (
    <section ref={sectionRef} className="section_block metrics-section">
      <div className="container">
        <div className="row text-center metrics-section-item align-items-start text-black py-5">
          {metrics.map((metric, index) => (
            <div key={index} className="col-6 col-md-4 col-lg-2 metrics">
              <div className="d-flex justify-content-center align-items-center">
                <h2 className="fw-bold counter">
                  {formatValue(values[index], metric.format || "+")}
                </h2>
              </div>
              <p className="paragraph">{metric.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MetricsSection;
